<template>
  <div class="hamburger-container" @click="toggleClick">
    <i :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'" class="hamburger"></i>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Hamburger',
  computed: {
    ...mapGetters(['sidebar']),
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  methods: {
    toggleClick() {
      this.$emit('toggleClick')
    }
  }
}
</script>

<style lang="scss" scoped>
.hamburger-container {
  padding: 0 10px;
  cursor: pointer;
  
  .hamburger {
    display: inline-block;
    vertical-align: middle;
    width: 20px;
    height: 20px;
    font-size: 20px;
    color: #5a5e66;
    line-height: 50px;
  }
  
  &:hover {
    .hamburger {
      color: #409EFF;
    }
  }
}
</style>
